<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY, TEXT_FONT_FAMILY} from './FactorCharts/chartStyle'

export default {
  name: 'LineChart',
  props: {
    nameLocation: String,
    factors: {
      required: true,
      type: Array
    },
    data: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    dataTimeFormat: {
      type: String,
      default: 'YY年MM月DD日HH时'
    }
  },
  computed: {
    dataTimes () {
      return this.data.data.map(data => data.dataTime)
    }
  },
  methods: {
    render (isReal) {
      let yAxis = this.buildYAxis()
      let series = this.buildSeries(yAxis)
      this.renderChart(yAxis, series, isReal)
    },
    buildYAxis () {
      let {factors, unitProp, nameLocation} = this
      return [...new Set(factors.map(factor => factor[unitProp]))].map((unit, index) => ({
        name: unit,
        type: 'value',
        nameLocation: nameLocation || 'end',
        nameGap: nameLocation ? 30 : 10,
        offset: Math.max(0, index - 1) * 40,
        axisLine: {
          show: true,
          lineStyle: AXIS_LINE_STYLE
        },
        splitLine: {
          show: index === 0
        },
        axisLabel: {
          ...AXIS_LABEL,
          fontFamily: NUMBER_FONT_FAMILY
        }
      }))
    },
    buildSeries (yAxis) {
      let {factors, unitProp, data: {data: dataList}} = this
      let showSymbol = typeof this.clickHandler === 'function'
      let unitIndexMap = yAxis.reduce((map, {name}, index) => {
        map[name] = index
        return map
      }, {})

      return factors.map(factor => {
        let factorId = factor.id
        return {
          id: factorId,
          name: factor.name,
          type: 'line',
          showSymbol: showSymbol,
          yAxisIndex: unitIndexMap[factor[unitProp]],
          data: dataList.map(data => data[factorId])
        }
      })
    },
    renderChart (yAxis, series, isReal) {
      let {dataTimes, data, nameLocation} = this
      // let ratio = Math.min(100, 100 / dataTimes.length * 100)
      let chartOpt = {
        title: {
          text: data.siteName,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        legend: {
          top: 27,
          left: 'center',
          width: '75%',
          type: 'scroll',
          selected: Object.assign({}, this.selected)
        },
        grid: [{
          top: 75,
          right: 40,
          bottom: 45,
          left: nameLocation ? 50 : 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: dataTimes,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY,
            formatter: date => new Date(date).format(this.dataTimeFormat)
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis,
        series
      }

      if (!isReal) {
        chartOpt.dataZoom = [{
          type: 'inside',
          start: this.dataTimes.length <= 72 ? 0 : ((this.dataTimes.length - 72) / this.dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: this.dataTimes.length <= 72 ? 0 : ((this.dataTimes.length - 72) / this.dataTimes.length * 100).toFixed(0),
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }]
      }

      this.$refs.chart.setOpt(chartOpt, isReal)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/LineChart.vue